<div class="d-flex justify-content-between">
  <h2 mat-dialog-title class="color-blue-cat">{{nameArchivo}}</h2>
  <a mat-icon-button (click)="closeDialog()">
    <mat-icon>clear</mat-icon>
  </a>
</div>

<div class="d-flex justify-content-center" *ngIf="loading">
  <mat-spinner></mat-spinner>
</div>

<mat-dialog-content class="mat-typography">
  <pdf-viewer 
    [src]="uriArchivoPDF" 
    [render-text]="true" 
    [show-borders]="true" 
    [original-size]="false" pdf-viewer max-width display
    [autoresize]="true"
    (on-progress)="loadingPDF($event)"
    style="display: block;">
  </pdf-viewer>
</mat-dialog-content>